export const emptyRichDocument = [
  {
    type: 'paragraph',
    children: [
      {
        text: '',
      },
    ],
  },
]

export const isDocumentEmpty = (document?: never) => {
  if (!document) {
    return true
  }
  return JSON.stringify(document) === JSON.stringify(emptyRichDocument)
}
